<template>
	<div class="widget p-lg text-center">
		<div class="m-b-md">
			<i class="fa-4x" :class="main_icon"></i>
			<h1 class="m-xs mt-2"><i :class="{'fa fa-check-circle': check, 'fa fa-times': !check}"></i></h1>
			<h3 class="font-bold no-margins">{{title}}</h3>
			<small v-if="subtitle">{{subtitle}}</small>
		</div>
	</div>
</template>

<script>
export default {
	props: { title: String, subtitle: String, main_icon: String, check: Boolean}
};
</script>
